export const ENGLISH_BLOG_SLUGS = Object.freeze({
  "membuat-plugin-vst-sendiri-tanpa-memulai-dari-nol": "build-your-own-vst-plugin-without-starting-from-scratch",
});
